export default __webpack_public_path__ + "static/media/no-image.d36e43a5.svg";